import request from "../utils/request";

export const getRangeProportions = '/sample/quality/controller/proportion/';

export function importExcel(file: File) {
    const formData = new FormData();
    formData.append('file', file);
    return request.post('/sample/quality/controller/proportion/', formData);
}

export function update(values: any) {
    return request.put('/sample/quality/controller/proportion/', values);
}

export function deleteProportion(proportionId: number) {
    return request.delete('/sample/quality/controller/proportion/', {params: {proportionId}})
}
